import BaseRequest from './base/BaseRequest'

export default class SiteSettingRequest extends BaseRequest {
    getSocialNetworks() {
        let url = '/socical-networks';
        return this.get(url);
    }
}
